<template>
  <Dashboard grafana-path="/d/ISSylgR7z/netradyne-distractions-pivot" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "NetradyneDistractionsDriverPivot",

  routing: {
    localizationKey: "menu.tab.distractions",
    icon: "mdi-table",
    path: "/netradyne_distractions",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
